/**
 * VisionLeadInSection - Vision framing before the system explanation
 *
 * Purpose: Communicate *why* the question matters, not how it is solved.
 * Feels philosophical, calm, and foundational.
 */
const VisionLeadInSection = () => {
    return (
        <section className="pt-14 pb-6 md:pt-16 md:pb-8 bg-background">
            <div className="container mx-auto max-w-2xl px-6">
                <h2 className="text-lg md:text-xl font-semibold text-foreground text-center mb-6">
                    In an ideal world
                </h2>

                <div className="space-y-5 text-[17px] md:text-lg text-foreground/85 leading-relaxed text-center">
                    <p>
                        In an ideal world, students would have access to unlimited high‑quality learning content and unlimited expert guidance.
                    </p>

                    <p>
                        Even in that world, one question remains fundamental:{' '}
                        <strong className="text-foreground font-semibold">
                            what should a student work on next to make the best use of their limited time?
                        </strong>
                    </p>

                    <p>
                        Pinpoint Edu is built around this question. We focus on decision quality in learning—identifying what matters most, prioritizing high‑impact skills, and guiding practice so time and effort translate into meaningful progress.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default VisionLeadInSection;
